/*
* PreprintedForms
 */
class PreprintedForms {
    constructor() {
        this.class = {
            target: '.js-filter',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * initialize functions
     */
    init() {
        this.filter();
    }

    /**
     * Filter behavior.
     */
    filter() {
        if (document.querySelectorAll(this.class.target).length > 0) {
            // Event listener for filterPerson on change.
            document.getElementById('filterPerson').addEventListener('change', () => {
                const filterPerson = document.getElementById('filterPerson');
                const filterOccasion = document.getElementById('filterOccasion');
                const filterYear = document.getElementById('filterYear');

                if (filterPerson.value !== '0') {
                    filterOccasion.disabled = false;
                } else {
                    filterOccasion.disabled = true;
                    filterYear.disabled = true;
                }

                if (filterOccasion.value !== '0') {
                    filterYear.disabled = false;
                } else {
                    filterYear.disabled = true;
                }
            });

            // Define the event listener for filterOccasion on change.
            document.getElementById('filterOccasion').addEventListener('change', () => {
                const filterOccasion = document.getElementById('filterOccasion');
                const filterYear = document.getElementById('filterYear');

                if (filterOccasion.value !== '0') {
                    filterYear.disabled = false;
                } else {
                    filterYear.disabled = true;
                }
            });

            // Initial state.
            const setInitialState = () => {
                const filterPerson = document.getElementById('filterPerson');
                const filterOccasion = document.getElementById('filterOccasion');
                const filterYear = document.getElementById('filterYear');

                // Check the initial value of filterPerson
                if (filterPerson.value === '0') {
                    // Set initial state when filterPerson is 0
                    filterOccasion.disabled = true;
                    filterYear.disabled = true;
                } else {
                    // Set initial state when filterPerson is not 0
                    filterOccasion.disabled = false;

                    // Check the initial value of filterOccasion
                    if (filterOccasion.value === '0') {
                        filterYear.disabled = true;
                    } else {
                        filterYear.disabled = false;
                    }
                }
            };
            setInitialState();
        }
    }
}

export default new PreprintedForms();
